/**
 * Locates users based on client IP
 * Intended only for vvolt.ca redirect
 */

// let userLocation = Intl.DateTimeFormat().resolvedOptions().timeZone;
fetch("https://ipinfo.io/json?token=05dd74e24a2577").then(
    (response) => response.json()
  ).then(
    (jsonResponse) => {
      console.log(jsonResponse.ip, jsonResponse.country)
      getCountryCode(jsonResponse.country);
    }
  )
  
  function getCountryCode(code) {
      if (code === 'CA') {
          generateModal();
  
          const modal = document.getElementById('id01');
          document.body.prepend(modal);
          modal.style.display = 'fixed';
      }
  }
  
  function retrieveCountryFromResults(res) {
      if (!res) return null;
  
      const index = res.indexOf("/");
      return index !== -1 ? res.substring(0, index) : res;
  }
  
  
  function generateModal() {
      // Create the modal element
      const modal = document.createElement('div');
      modal.id = 'id01';
      modal.classList.add('redirect-modal');
  
      // Create the modal content
      const modalContent = document.createElement('div');
      modalContent.classList.add('redirect-modal-content');
  
      // Create the container for the modal content
      const container = document.createElement('div');
      container.classList.add('redirect-container');
  
      // Create the close button
      const closeButton = document.createElement('span');
      closeButton.classList.add('close-button', 'redirect-display-topright');
      closeButton.textContent = '×';
      closeButton.style = `
          font-size: 1.5rem;
          font-weight: 800;
      `
      closeButton.addEventListener('click', () => {
          modal.style.display = 'none';
      });
  
      // Create the text paragraphs
      const p1 = document.createElement('h3');
      p1.textContent = 'Seems like you are visiting from Canada';
      p1.style = `
          text-align: center;
          font-size: 1.05rem;
          margin-bottom: 0;
          padding-bottom: 0;
          text-transform: uppercase;
      `
      const p2 = document.createElement('p');
      p2.style = `
          text-align: center;
          font-size: 0.95rem;
          margin-bottom: 0.25rem;
      `
      p2.textContent = 'For a more localized shopping experience, we encourage you to visit our store in Canada.';
  
      const p3 = document.createElement('p');
      // Create the anchor element with link
      const link = document.createElement('a');
      link.textContent = "Click here";
      link.href = "https://vvolt.ca";  // Replace with your actual link
      // Append the anchor to the paragraph
      p3.appendChild(link);
      const remainingText = document.createTextNode(" to be redirected.");
      p3.appendChild(remainingText);
  
      // Apply styles to the paragraph (and optionally link)
      p3.style = `
          text-align: center;
          font-size: 0.95rem;
          margin-bottom: 1.5rem;
      `;
      link.style = `
          color: #193d9e;
      `
  
      // Assemble the elements
      container.appendChild(closeButton);
      container.appendChild(p1);
      container.appendChild(p2);
      container.appendChild(p3);
      modalContent.appendChild(container);
      modal.appendChild(modalContent);
  
      // Add the modal to the document body (or any desired location)
      document.body.appendChild(modal);
  }